import { app } from '@/bootloader';
import IncompatibleBrowserServiceInstall from '@/modules/IncompatibleBrowserService';

app.use(IncompatibleBrowserServiceInstall);
